export default __webpack_public_path__ + "static/media/ep-home.41ec559d.png";